import React from "react";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import AddEditpage from "./addEditpage";

const EditEstimate = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Edit Estimate"
            title="Main"
            subtitle="Edit Estimate"
            modalClass="col-auto float-end ms-auto"
          />
          <AddEditpage />
        </div>
      </div>
    </>
  );
};

export default EditEstimate;
